import PrivacyPolicyContent from "$lib/data/generated/content/privacy policy/data.json";

import { uploads as PrivacyPolicyUploads } from "$lib/data/generated/uploads/privacy policy/uploads";

const content = {
	["privacy policy"]: PrivacyPolicyContent
};
const uploads = {
	...PrivacyPolicyUploads
};


export const prerender = 'auto';
export const entries = () => {
	if (false) return [];
	return ['/admin'];
};

export const load = async ({ parent }) => {
	const data = await parent();

	data.content = { ...data.content, ...content };
	data.uploads = { ...data.uploads, ...uploads };

	return data;
};
